import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-sort-icon',
  templateUrl: 'sort-icon.component.html',
  styleUrls: ['sort-icon.component.scss']
})
export class SortIconComponent {
}
